import React from "react";
import { Card, Space, Typography, Select, Row, Col, InputNumber, Slider, Tooltip } from "antd";

const { Text } = Typography;
const { Option } = Select;

/**
 * 设备与缩放控制
 * 说明：缩放只改变“显示比例”（transform: scale），不改变设备的宽/高配置。
 */
export default function DeviceControls({
  PRESETS,
  deviceId,
  setDeviceId,
  size,
  setSize,
  scale,
  setScale,
  activePreset,
  previewTargets,
  previewTarget,
  onChangePreviewTarget,
}) {
  const isCustom = Boolean(activePreset?.isCustom);

  return (
    <Card
      size="small"
      className="overflow-hidden rounded-[26px] border border-[#e3e9f8] shadow-[0_18px_40px_rgba(30,52,120,0.08)]"
      headStyle={{ borderBottom: "1px solid #e8edf8", padding: "18px 22px", minHeight: "unset" }}
      bodyStyle={{ padding: "20px 18px" }}
      style={{ marginBottom: 12 }}
    >
      <Space direction="vertical" style={{ width: "100%" }} size={14}>
        {Array.isArray(previewTargets) && previewTargets.length > 0 ? (
          <div>
            <Text style={{ fontSize: 15, color: "#334155", fontWeight: 500 }}>Preview Target</Text>
            <Select
              value={previewTarget}
              onChange={onChangePreviewTarget}
              style={{ width: "100%", marginTop: 6 }}
              options={previewTargets}
            />
          </div>
        ) : null}

        <div>
          <Text style={{ fontSize: 15, color: "#334155", fontWeight: 500 }}>Device</Text>
          <Select value={deviceId} onChange={setDeviceId} style={{ width: "100%", marginTop: 6 }}>
            {PRESETS.map((d) => (
              <Option key={d.id} value={d.id}>
                {d.name} · {d.w}×{d.h}
              </Option>
            ))}
          </Select>
        </div>

        {isCustom && (
          <Row gutter={8}>
            <Col span={12}>
              <Text style={{ fontSize: 15, color: "#334155", fontWeight: 500 }}>Width</Text>
              <InputNumber
                min={200}
                value={size.w}
                onChange={(v) => setSize((s) => ({ ...s, w: Number(v || 0) }))}
                style={{ width: "100%", marginTop: 6 }}
              />
            </Col>
            <Col span={12}>
              <Text style={{ fontSize: 15, color: "#334155", fontWeight: 500 }}>Height</Text>
              <InputNumber
                min={300}
                value={size.h}
                onChange={(v) => setSize((s) => ({ ...s, h: Number(v || 0) }))}
                style={{ width: "100%", marginTop: 6 }}
              />
            </Col>
          </Row>
        )}

        <div>
          <Space style={{ width: "100%", justifyContent: "space-between" }}>
            <Text style={{ fontSize: 15, color: "#334155", fontWeight: 500 }}>Zoom</Text>
            <Tooltip title="Zoom only changes display scale, not layout width/height.">
              <Text type="secondary">{Math.round(scale * 100)}%</Text>
            </Tooltip>
          </Space>
          <Slider
            min={40}
            max={160}
            value={Math.round(scale * 100)}
            onChange={(v) => setScale(Number(v) / 100)}
          />
        </div>
      </Space>
    </Card>
  );
}
